import React from "react";
import MuPb from "../../../widgets/MuPb";
import { Alert, Box } from "@mui/material";
import ProductDetail from "./ProductDetail";
import { useParams } from "react-router-dom";
import BackBtn from "../../../widgets/BackBtn";
import useApiEp from "../../../hooks/useApiEp";

const ProductContainer = () => {
  const { id } = useParams();
  const { data, isLoading, isError, error } = useApiEp(
    `/user/get-product-by-id?id=${id}&`
  );
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{error?.message}</Alert>;
  }
  return (
    <Box pl={2} pt={1} pr={2}>
      <BackBtn />
      <Box>
        <ProductDetail product={data} />
      </Box>
    </Box>
  );
};

export default ProductContainer;
